module.exports = __webpack_public_path__ + "img/ruler.9c126c85.svg";